import { useTheme } from "../contexts/ThemeContext";

export function useThemeColors() {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return {
    bgPrimary:    dark ? "#09090D" : "#F2F0EB",
    bgSecondary:  dark ? "#111318" : "#E8E5DE",
    bgCode:       dark ? "#1A1C23" : "#E0DDD5",
    border:       dark ? "#1E2028" : "#D4D0C8",
    textMuted:    dark ? "#9BA4B5" : "#7A7669",
    textPrimary:  dark ? "#FFFFFF" : "#1A1916",
    bgSurface:    dark ? "#111318" : "#FAFAF7",
    signal:       dark ? "#2058F0" : "#1B4FE0",
    signalHover:  dark ? "#0044E0" : "#1340C8",
    signalSubtle: dark ? "#E8EEFF" : "#DDE6FF",
    aurora:       dark ? "#7C3AED" : "#6D28C8",
    auroraLight:  dark ? "#A78BFA" : "#9333EA",
    ember:        dark ? "#F97316" : "#E85C00",
    carbon:       dark ? "#1E2028" : "#D4D0C8",
    steel:        dark ? "#9BA4B5" : "#7A7669",
    // hero headline gradient
    heroGradient: dark
      ? "linear-gradient(112deg, #E6E9F4 22%, #C4B5FD 100%)"
      : "linear-gradient(112deg, #6D28C8 0%, #9333EA 100%)",
  };
}
